
window.addEventListener('load', function () {
  try {
    document.querySelector('.yotpo-main-widget')
            ?.parentElement
            ?.parentElement
            ?.classList.add('wrapper__yopto-with-page-width')
    document.querySelector('.yotpo-main-widget')?.setAttribute("id", "reviews_place")


    const reviews = document.querySelector('.yotpo-main-widget')?.parentElement;
    const config = { attributes: true, childList: true, subtree: true };
    let title = document.createElement("div");
    title.classList.add('yotpo-custom-reviews-title');
    let text = document.createTextNode("Customer Reviews");
    title.appendChild(text);
    //append to app element
    reviews.querySelector('.yotpo-display-wrapper').appendChild(title);

    const observer = new MutationObserver(function (_, observer) {

        const observer1 = new MutationObserver(function (_, observer1) {

            const reviews1 = document.querySelectorAll('.yotpo-display-wrapper');

            //building
//             let title = document.createElement("div");
//             title.classList.add('yotpo-custom-reviews-title');
//             let text = document.createTextNode("Customer Reviews");
//             title.appendChild(text);
//             //append to app element
//             reviews.querySelector('.yotpo-display-wrapper').appendChild(title);


            $jq('.anchor.reviews').click(function(){
                $jq('html, body').animate({
                    scrollTop: $jq('.yotpo-main-widget').offset().top - $jq('sticky-header.header-wrapper').height() - 80
                }, 2000);
            })


            const observer2 = new MutationObserver(function (_, observer1) {

                let yotponav = reviews.querySelector('.yotpo-nav.yotpo-nav-primary');
                let childrenList = yotponav.querySelectorAll('.yotpo-nav-tab');
                let reviewsButt = childrenList[0];
                let questionsButt = childrenList[1];

                let writeQuestionButton = document.querySelectorAll('.write-question-button');
                let writeReviewButton = document.querySelectorAll('.write-button.write-review-button');

                writeQuestionButton.forEach( (btn) => {
                    btn.classList.add('hidden');
                });

                reviewsButt.addEventListener('click', function() {
                    writeQuestionButton.forEach( (btn) => {
                        btn.classList.add('hidden');
                        btn.classList.remove('show');
                    });
                    writeReviewButton.forEach( (btn) => {
                        btn.classList.remove('hidden');
                    });
                });

                if (questionsButt) {
                    questionsButt.addEventListener('click', function() {
                        writeQuestionButton.forEach( (btn) => {
                            btn.classList.remove('hidden');
                            btn.classList.add('show');
                        });
                        writeReviewButton.forEach( (btn) => {
                            btn.classList.add('hidden');
                        });
                    });
                }

                observer2.disconnect();
            });

            observer2.observe(reviews.querySelector('.yotpo-display-wrapper'), config);

            observer1.disconnect();
        });

        observer1.observe(reviews, config);


        observer.disconnect();

    });

    observer.observe(reviews, config);
  } catch (error) {

  }
});
